/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Teams_Is_RequiredInputs */

const en_tables_teams_is_required = /** @type {(inputs: Tables_Teams_Is_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Required`)
};

const de_tables_teams_is_required = /** @type {(inputs: Tables_Teams_Is_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Required`)
};

/**
* | output |
* | --- |
* | "Is Required" |
*
* @param {Tables_Teams_Is_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_teams_is_required = /** @type {((inputs?: Tables_Teams_Is_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Teams_Is_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_teams_is_required(inputs)
	return de_tables_teams_is_required(inputs)
});